// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2192":"c20a2752","2429":"12826df6","2458":"5accebe4","5495":"0dd2cb89","5606":"23580551","8216":"23580551","9859":"23580551"}[chunkId] + ".chunk.css";
};